import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class SnackBarService {

  constructor(private _snackBar: MatSnackBar) {
  }


  /***************************************************************
   * For show Success message with action
   * this.snackbarService.open("Hello", "success", "ok")
   * For show Error message with action
   * this.snackbarService.open("Hello", "error", "ok")
   * *************************************************************/
  open(message: string, type: 'success' | 'error' | 'info' | 'warning' = 'success', action?: string): void {
    this._snackBar.dismiss();
    let cl = 'toasterSuccessClass';
    let duration = 3000;
    if (type === 'error') {
      cl = 'toasterErrorClass';
      duration = 5000;
    }
    this._snackBar.open(message, action, {
      duration,
      horizontalPosition: 'end'
    });
  }

  openWithConfig(message: string, type: 'success' | 'error' | 'info' | 'warning' = 'success', action?: string, config?: any): void {
    this._snackBar.dismiss();
    let cl = 'toasterSuccessClass';
    let duration = config.duration ? config.duration : 3000;
    if (type === 'error') {
      cl = 'toasterErrorClass';
      duration = 5000;
    }
    if (type === 'info') {
      cl = 'toasterInfoClass';
    }
    config.panelClass = [cl];
    this._snackBar.open(message, action, {...config});
  }
}
